<span class="fill-space">
  <span id="buttons-container">
    <img *ngIf="!isMinimalLayout" class="image" [src]="imageSource" />
    <span class="toolbar-button">
      <button mat-button class="menu-button" (click)="clickHome()" type="button" [ngClass]="getButtonClass('/cockpit/start')">
        <mat-icon *ngIf="!isMinimalLayout" class="toolbar-icon">home</mat-icon>
        {{ 'home.title' | transloco }}
      </button>
    </span>
    <span *ngIf="!isAdmin && !isValidator && isContractSigned" class="toolbar-button">
      <button mat-button class="menu-button" [matMenuTriggerFor]="packagingMenu" type="button" [ngClass]="getButtonClass('/cockpit/packaging')">
        <mat-icon *ngIf="!isMinimalLayout" class="toolbar-icon">bento</mat-icon>
        {{ 'common.text.packaging' | transloco }}
      </button>
    </span>
    <span *ngIf="isContractSigned || isAdmin" class="toolbar-button">
      <button mat-button class="menu-button" [matMenuTriggerFor]="dataMenu.menu" type="button" [ngClass]="getButtonClass('/cockpit/data-management')">
        <mat-icon *ngIf="!isMinimalLayout" class="toolbar-icon">settings</mat-icon>
        {{ 'dataManagement.title' | transloco }}
      </button>
    </span>
    <span *ngIf="!isAdmin && !isValidator && isContractSigned" class="toolbar-button">
      <button mat-button class="menu-button" [matMenuTriggerFor]="evalMenu" type="button" [ngClass]="getButtonClass('/cockpit/data-evaluation')">
        <mat-icon *ngIf="!isMinimalLayout" class="toolbar-icon">analytics</mat-icon>
        {{ 'dataEvaluation.title' | transloco }}
      </button>
    </span>
    <span class="toolbar-button">
      <button mat-button class="menu-button" [matMenuTriggerFor]="downloadsMenu.menu" type="button">
        <mat-icon *ngIf="!isMinimalLayout" class="toolbar-icon">download</mat-icon>
        {{ 'downloads.title' | transloco }}
      </button>
    </span>
  </span>
  <span id="user-container">
    <mat-form-field appearance="outline" class="search-field">
      <input matInput placeholder="{{ 'searchDialog.Search' | transloco }}" [formControl]="searchControl" (keyup.enter)="onSearch()" autocomplete="off" />
      <button mat-icon-button matSuffix matSuffix (click)="onSearch()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>

    <span *ngIf="!isMinimalLayout" class="toolbar-text">
      {{ 'dataManagement.userData.texts.signedInAs' | transloco }}
    </span>

    <button mat-button class="menu-button user-button" [matMenuTriggerFor]="userMenu" type="button">
      <mat-icon *ngIf="!isMinimalLayout" class="color-icon" aria-hidden="false">account_circle</mat-icon>
      {{ username }}
    </button>

    <button mat-button class="menu-button user-button" (click)="updateNotificationMenu()" [matMenuTriggerFor]="notificationMenu" type="button">
      <mat-icon matBadgeSize="small" class="color-icon" [matBadge]="allNotifications" [matBadgeHidden]="allNotifications === 0" matBadgeColor="warn"> notifications </mat-icon>
    </button>

    <button mat-button class="menu-button user-button" (click)="clickContactInfo()" type="button">
      <mat-icon *ngIf="!isMinimalLayout" class="color-icon">info</mat-icon>
      {{ 'contactInfo.buttonText' | transloco }}
    </button>

    <a mat-button class="menu-button user-button" type="button" target="_blank" href="{{ 'shop.webshopLink' | transloco }}">
      <mat-icon *ngIf="!isMinimalLayout" class="color-icon">shopping_cart</mat-icon>
      {{ 'shop.webshop' | transloco }}
    </a>
  </span>

  <app-data-menu #dataMenu></app-data-menu>

  <mat-menu #evalMenu="matMenu" [overlapTrigger]="false">
    <app-evaluations-menu></app-evaluations-menu>
  </mat-menu>

  <app-downloads-menu #downloadsMenu></app-downloads-menu>

  <mat-menu #userMenu>
    <button mat-menu-item (click)="clickMyProfile()" type="button">
      <mat-icon class="toolbar-icon">account_circle</mat-icon>
      {{ 'myProfile.banner.title' | transloco }}
    </button>

    @if (canManageOrganization) {
      <button mat-menu-item (click)="clickOrganisationSettings()" type="button">
        <mat-icon class="toolbar-icon">settings</mat-icon>
        {{ 'dataManagement.userData.texts.organisationSettings' | transloco }}
      </button>
    }

    <button mat-menu-item [matMenuTriggerFor]="creditsMenu" type="button" *ngIf="!creditsService.areCreditsInfinite()">
      <mat-icon class="toolbar-icon" [matBadge]="'!'" [matBadgeHidden]="!creditsService.areCreditsRunningLow()" matBadgeColor="warn" matBadgeSize="small" aria-hidden="false"
        >stars</mat-icon
      >
      <span>Credits</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="themeMenu" type="button">
      <mat-icon class="toolbar-icon">invert_colors</mat-icon>
      <span>{{ 'dataManagement.userData.texts.colorTheme.menuItem' | transloco }}</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="languageMenu" type="button">
      <mat-icon class="toolbar-icon">language</mat-icon>
      <span>{{ 'language.language' | transloco }}</span>
    </button>
    <button mat-menu-item (click)="clickSignOut()" #signOut type="button">
      <mat-icon class="toolbar-icon">exit_to_app</mat-icon>
      {{ 'dataManagement.userData.texts.signOut' | transloco }}
    </button>
    <button mat-menu-item disabled id="version"><app-version></app-version></button>
  </mat-menu>

  <mat-menu #notificationMenu>
    <app-notification-menu></app-notification-menu>
  </mat-menu>

  <mat-menu #creditsMenu="matMenu" [class]="'credits-menu' + (creditsService.areCreditsRunningLow() ? ' low' : '') + (isDarkTheme ? ' dark-theme' : '')">
    <div class="credits-menu-content">
      <div class="credits-header">
        <mat-icon>stars</mat-icon>
        <span>{{ 'confirmAnalysisDialog.yourCredits' | transloco }}</span>
      </div>

      <div class="credits-divider"></div>

      <div class="credit-item" *ngIf="!creditsService.areLcaCreditsInfinite() && isPremiumUser" [class.low]="creditsService.areLcaCreditsRunningLow()">
        <div class="credit-label">
          <mat-icon class="credit-icon">eco</mat-icon>
          <span>{{ 'dataManagement.manageOrganizations.bulkUpload.creditsLca' | transloco }}</span>
        </div>
        <span class="credit-value">{{ creditsService.creditsCount.lcaCredits | number }}</span>
      </div>

      <div class="credit-item" *ngIf="!creditsService.areRycyclingCreditsInfinite()" [class.low]="creditsService.areRecyclabilityCreditsRunningLow()">
        <div class="credit-label">
          <mat-icon class="credit-icon">recycling</mat-icon>
          <span>{{ 'dataManagement.manageOrganizations.bulkUpload.creditsRecyclability' | transloco }}</span>
        </div>
        <span class="credit-value">{{ creditsService.creditsCount.recyclabilityCredits | number }}</span>
      </div>

      <ng-container *ngIf="creditsService.areLcaCreditsRunningLow() || creditsService.areRecyclabilityCreditsRunningLow()">
        <div class="credits-divider"></div>
        <div class="credits-upgrade-hint">
          <mat-icon class="hint-icon">info</mat-icon>
          <span>
            {{ 'dataManagement.manageOrganizations.accountsTableColumn.upgradeHint' | transloco }}
            <a href="mailto:upgrade@packaging-cockpit.com" class="upgrade-link" (click)="$event.stopPropagation()"> upgrade&#64;packaging-cockpit.com </a>
          </span>
        </div>
      </ng-container>
    </div>
  </mat-menu>

  <mat-menu #themeMenu>
    <button *ngFor="let colorTheme of colorThemes" mat-menu-item (click)="setColorTheme(colorTheme.id)" type="button">
      {{ colorTheme.name }}
    </button>
  </mat-menu>

  <mat-menu #languageMenu>
    <button *ngFor="let countryCode of countryCodes" mat-menu-item (click)="setLanguage(countryCode)" id="language-{{ countryCode }}">
      <span class="flag-icon flag-icon-{{ countryCode }} space-right"></span>
      {{ 'language.' + countryCode | transloco }}
    </button>
  </mat-menu>

  <mat-menu #packagingMenu>
    <button mat-menu-item (click)="clickMaterialHome()" type="button">
      <img class="image-icon" [src]="getPackagingPartImage(packagingPart.Material)" />
      <span>{{ 'home.materialHome.title' | transloco }}</span>
    </button>
    <button mat-menu-item (click)="clickComponentsHome()" type="button">
      <img class="image-icon" [src]="getPackagingPartImage(packagingPart.Component)" />
      <span>{{ 'home.componentHome.title' | transloco }}</span>
    </button>
    <button mat-menu-item (click)="clickPackagingUnitHome()" type="button">
      <img class="image-icon" [src]="getPackagingPartImage(packagingPart.Unit)" />
      <span>{{ 'home.packagingUnitHome.title' | transloco }}</span>
    </button>
    <button mat-menu-item (click)="clickPackagingSystemHome()" type="button">
      <img class="image-icon" [src]="getPackagingPartImage(packagingPart.System)" />
      <span>{{ 'home.packagingSystemHome.title' | transloco }}</span>
    </button>
  </mat-menu>
</span>
